import throttle from 'lodash/throttle';

import { LocalCache } from '../core/src/local-storage-cache';
import { UPDATE_COMPARE_PRODUCTS, CLEAR_COMPARE_PRODUCTS } from '../compare/compare-actions';

/**
 * For now keep everything in the same namespace with a 1 day expiration
 */
const localCache = new LocalCache('presistedReduxState', 1); 

const saveState = throttle((key, value) => {
    localCache.set(key, value);
},1000);

export const getPresistedState = () => {
    return localCache.data()
}

/**
 * Middleware for tracking state changes and presisting parts of the redux store to local storage
 */
export default function presistStoreMiddleware({getState}) {
	return next => action => {
		const returnValue = next(action);
		switch (action.type) {
            case CLEAR_COMPARE_PRODUCTS:
			case UPDATE_COMPARE_PRODUCTS:
            {
                saveState('compare',getState().compare);
			}
		}

		return returnValue;
	};
}
